import { Link } from "react-router-dom";
import { ArrowRight, Tag, Flag } from "lucide-react";
import { collectionFor, badgeOn, cap } from "../lib/useCaseCollections.mjs";

export default function FlagshipSpotlight({ basePath, flip = false }) {
  const c = collectionFor(basePath);
  if (!c) return null;
  const Icon = c.spotlight.icon === "flag" ? Flag : Tag;
  const lead = c.badges[0];
  return (
    <section className={`${flip ? "bg-kolt-paper-soft" : "bg-white"} border-y border-slate-200 py-16 lg:py-20`} data-testid={`${c.key}-spotlight`}>
      <div className="container-page grid lg:grid-cols-5 gap-10">
        <div className={`lg:col-span-2 ${flip ? "lg:order-2" : ""}`}>
          <div className="overline mb-3 flex items-center gap-2"><Icon className="w-3.5 h-3.5 text-kolt-orange" /> {c.spotlight.overline}</div>
          <h2 className="font-display font-black text-4xl tracking-tight text-kolt-slate-dark leading-[0.95]">{c.spotlight.titleA}<span className="text-kolt-orange">{c.spotlight.titleB}</span></h2>
          <p className="text-slate-600 mt-5 leading-relaxed">{c.spotlight.blurb}</p>
          <div className="flex flex-wrap gap-3 mt-6">
            <Link to={c.hubPath} className="btn-primary inline-flex items-center gap-2" data-testid={`${c.key}-spotlight-shop`}>{c.spotlight.shopLabel} <ArrowRight className="w-4 h-4" /></Link>
            <Link to={c.spotlight.toolPath} className="px-5 py-3 border border-slate-300 hover:border-kolt-slate-dark font-mono text-[11px] tracking-[0.22em] uppercase font-bold" data-testid={`${c.key}-spotlight-tool`}>{c.spotlight.toolLabel}</Link>
          </div>
          <div className="mt-8">
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-slate-500 mb-2">{c.spotlight.chipsLabel}</div>
            <div className="flex flex-wrap gap-2">
              {c.useCases.map((u) => <Link key={u.slug} to={`${c.basePath}/${u.slug}`} className="px-3 py-1.5 border border-slate-200 hover:border-kolt-orange text-xs text-slate-700 bg-white" data-testid={`${c.key}-spotlight-use-${u.slug}`}>{cap(u.keyword)}</Link>)}
            </div>
          </div>
        </div>
        <div className={`lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 ${c.stocks.length > 9 ? "lg:grid-cols-4" : ""} gap-3 ${flip ? "lg:order-1" : ""}`}>
          {c.stocks.map((s) => (
            <Link key={s.slug} to={c.productPath(s.slug)} className={`border border-slate-200 hover:border-kolt-orange p-4 group transition-colors ${flip ? "bg-white" : "bg-kolt-paper-soft"}`} data-testid={`${c.key}-spotlight-stock-${s.slug}`}>
              <div className="font-bold text-kolt-slate-dark text-sm">{s.name}</div>
              <div className="text-xs text-slate-500 mt-1">{s.finish}</div>
              {c.stocks.length <= 9 && <div className="text-[11px] text-slate-600 mt-2">{s.best}</div>}
              {badgeOn(s, lead) && <div className={`mt-2 inline-block font-mono text-[9px] tracking-widest uppercase px-1.5 py-0.5 ${lead.chipClass}`}>{lead.yes}</div>}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
